import CrudPage from "../components/CrudPage";

export default function Customers() {
  return <CrudPage
    title="Clientes" subtitle="Cadastro de Clientes" endpoint="/customers" testPrefix="customers"
    fields={[
      { k: "name", label: "Nome" },
      { k: "phone", label: "Telefone" },
      { k: "email", label: "Email" },
      { k: "cpf", label: "CPF" },
      { k: "address", label: "Endereço" },
      { k: "birth_date", label: "Nascimento", type: "date" },
      { k: "notes", label: "Observações", hidden: true },
    ]}
  />;
}
